<template>
	<div>
		<div class="row">
			<div class="col-12 col-lg-12">
				<div
					v-for="(item, index) in block.items"
					:id="`card-${item.position}`"
					:key="index"
					class="media_cards"
				>
					<div class="media_cards__header">
						<div class="col-12 col-lg-2">
							<div class="number-item border-lg-bottom">
								{{ item.name }}
							</div>
						</div>
						<div class="col-12 col-lg-10">
							<div class="border-bottom">
								<h2 class="title title-lg">
									{{ item.title }}
								</h2>
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-10 offset-lg-2">
						<div class="media_cards__body">
							<div class="description" v-html="item.description" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'PanelCards',
	mixins: [panel],
};
</script>

<style lang="scss" scoped>
@import "assets/styles/components/dev/draft-cards-media";
</style>
